import React from 'react'

const Orderplaced = () => {
  return (
    <div style={{margin:"auto",width:"50%"}}>
<img src="https://cdn.dribbble.com/users/2139038/screenshots/4434155/ui-animation.gif" />
    </div>
  )
}

export default Orderplaced